export const dataHooks = {
  link: 'announcementModalLayout-link',
};
